import axios from '@/plugins/axios'

export function getOrderRent(params = {}) {
  return axios.get('orderRent', {
    params,
  })
}

export function orderRentLocationsearch(params = {}) {
  return axios.get('orderRent/orderRentLocationsearch', {
    params,
  })
}

export function getOrderRentLocation(params = {}) {
  return axios.get('orderRent/orderRentLocation', {
    params,
  })
}

export function getOrderRentStatus() {
  return axios.get('orderRent/orderRentStatus')
}

export function getOrderRentBikeOperate(params = {}) {
  return axios.get('orderRent/orderRentBikeOperate', {
    params,
  })
}

export function closeLock(data) {
  return axios.post('orderRent/closeLock', data)
}

export function settlementOrderRent(data) {
  return axios.post('orderRent/settlement', data)
}

export function returnOrderMoney(data) {
  return axios.post('orderRent/returnOrderMoney', data)
}

export function getOrderRentTrajectory(data) {
  return axios.post('bike/getOrderRentTrajectory', data)
}

export function orderRentDetailPosition(data) {
  return axios.post('orderRent/orderRentDetailPosition', data)
}

export function updateOrderRent(id, data) {
  return axios.put(`orderRent/${id}`, data)
}

export function changeRentOrderRiding(data) {
  return axios.post('orderRent/changeRentOrderRiding', data)
}

export function BikeControByOrderRent(data) {
  return axios.post('orderRent/orderBikeContro', data)
}
